import React, { useState, useCallback } from "react";
import { getRouteApi } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { DateTime } from "luxon";
//
import { DatePickerInput } from "@mantine/dates";
import { Stack, Center, Button } from "@mantine/core";

import {
  chooseBestGranularity,
  type TimePeriod,
} from "@utils/chart-data-conversions/timelines";

const route = getRouteApi("/_authenticated/app/players/$playerId/insights");

interface SpecificDatesSelectProps {
  onSubmit: (tp: TimePeriod) => void;
}

export const SpecificDatesSelect = (
  props: SpecificDatesSelectProps,
): React.ReactElement => {
  const { t } = useTranslation();
  const { onSubmit } = props;

  const { startDate: startDateStr, endDate: endDateStr } = route.useSearch();

  const [startDateInputVal, setStartDateInputVal] = useState<Date | null>(
    new Date(startDateStr),
  );

  const [endDateInputVal, setEndDateInputVal] = useState<Date | null>(
    new Date(endDateStr),
  );

  const handleSubmit = useCallback(() => {
    // i'm not allowing de-select so no need to handle this w/ error UI
    if (!startDateInputVal || !endDateInputVal) {
      return;
    }

    const start = DateTime.fromJSDate(startDateInputVal);
    const end = DateTime.fromJSDate(endDateInputVal);

    onSubmit({
      start,
      end,
      granularity: chooseBestGranularity(start, end),
    });
  }, [startDateInputVal, endDateInputVal, onSubmit]);

  return (
    <Stack>
      <DatePickerInput
        label={t("playerInsights.configureSection.startDate")}
        value={startDateInputVal}
        onChange={setStartDateInputVal}
      />
      <DatePickerInput
        label={t("playerInsights.configureSection.endDate")}
        value={endDateInputVal}
        onChange={setEndDateInputVal}
      />
      <Center>
        <Button
          variant="filled"
          w={{ sm: "100%", md: "50%" }}
          onClick={handleSubmit}
        >
          {t("submit")}
        </Button>
      </Center>
    </Stack>
  );
};
